import React, { useState } from 'react';
import { Upload, Button, Input } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

export default function FileUpload({formats = ["pdf"], cb, placeholder="Select File"}){
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = e => {
    const file = e.target.files[0];
    setSelectedFile(file);
    cb(file)
  };

  const handleUpload = () => {
    cb(selectedFile)
    // Reset selectedFile state after upload
    setSelectedFile(null);
  };

  return (
    <div style={{marginBottom: "2em"}}>
      <input
        type="file"
        accept={formats.map(e => `.${e}`).reduce((a, b) => `${a};${b}`)} // Limit accepted file types if needed
        onChange={handleFileChange}
        style={{ display: 'none' }}
        id="fileInput"
      />
      <Input
        readOnly
        value={selectedFile ? selectedFile.name : ''}
        onClick={() => document.getElementById('fileInput').click()}
        placeholder={placeholder}
        // suffix={
        //   <Button
        //     type="default"
        //     onClick={() => document.getElementById('fileInput').click()}
        //     icon={<UploadOutlined style={{paddingLeft: ".3em", paddingRight: ".5em"}} />}
        //   />
        // }
      />
      {/* <Button
        type="primary"
        onClick={handleUpload}
        disabled={!selectedFile}
        style={{ marginTop: 16 }}
      >
        Upload
      </Button> */}
    </div>
  );
};
